import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import Section from "./components/Section";
import store from "./store";
import { Provider } from "react-redux";
import { Provider as ReduxQueryProvider } from "redux-query-react";
// require("./index.css"); // <-- include if run locally

const root = ReactDOM.createRoot(document.getElementById("root"));

export const getQueries = (state) => state.queries;
const { sections, regionAnalysisIds } = window.data;

const ScrollHandler = ({ sections }) => {
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const elementId = query.get("graph");
    const scrollToElement = (id) => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    };

    if (elementId) {
      setTimeout(() => {
        if (elementId === "business") {
          scrollToElement("forventningsundersokelse");
        } else if (elementId === "private") {
          scrollToElement("forventningsundersokelse-folk");
        }
      }, 500);
    }
  }, [sections]);
  return null;
};

root.render(
  <React.Fragment>
    <Provider store={store}>
      <ReduxQueryProvider queriesSelector={getQueries}>
        <ScrollHandler sections={sections} />
        {sections.map((section, i) => {
          if (!section.modules) {
            return null;
          }
          if (section.hideGraph) {
            return null;
          }
          return (
            <div className={`chart-wrapper ${section.cssmodifier}`} key={`section-${i}`} id={`${section.sectionId}`}>
              <div className="chart-wrapper__inner">
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <Section {...section} index={i} regionAnalysisIds={regionAnalysisIds} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </ReduxQueryProvider>
    </Provider>
  </React.Fragment>
);
